/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */

import ContentBox from '~/components/ContentBox';
import LoadingArea from '~/components/LoadingArea';
import RedesignedTextField from '~/components/RedesignedTextField';
import SegmentTile from '~/images/Tiles/Segment/Segment.svg';

import Category from './Category';
import SearchIcon from './SearchIcon.svg';
import styles from './styles';

const SegmentPicker = ({
  type,
  personCollections,
  companyCollections,
  classes,
  onChange,
  footerActions,
  className,
  title,
}) => {
  const [search, setSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [selectedCollection, setSelectedCollection] = useState(undefined);

  if (!personCollections && !companyCollections) return <LoadingArea loading />;

  const selectCategory = (category) => {
    setSelectedCategory(category === selectedCategory ? undefined : category);
  };

  const selectCollection = (collection) => {
    setSelectedCollection(
      collection.id === selectedCollection?.id ? undefined : collection,
    );
  };

  const selectSegment = (segment) => {
    onChange(segment);
  };

  const filteredPersonCollections =
    personCollections?.map((c) => ({
      ...c,
      segments: c?.segments?.filter((s) =>
        s.name.toLowerCase().includes(search.toLowerCase()),
      ),
    })) || [];
  const filteredCompanyCollections =
    companyCollections?.map((c) => ({
      ...c,
      segments: c?.segments?.filter((s) =>
        s.name.toLowerCase().includes(search.toLowerCase()),
      ),
    })) || [];

  return (
    <div className={classnames(classes.root, className)}>
      <ContentBox.Section variant="horizontal">
        {title || (
          <>
            <ContentBox.Icon>
              <SegmentTile />
            </ContentBox.Icon>
            Choose a {type === 'All' && 'person or'} company segment
          </>
        )}

        <RedesignedTextField
          value={search}
          className={classes.search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Find existing segment"
          InputProps={{
            startAdornment: <SearchIcon className={classes.searchIcon} />,
          }}
        />
      </ContentBox.Section>
      <div className={classes.table}>
        {type !== 'Company' && (
          <Category
            name="Person"
            collections={filteredPersonCollections}
            onChange={onChange}
            keepOpen={type === 'Person'}
            selectedCategory={selectedCategory}
            setSelectedCategory={selectCategory}
            selectedCollection={selectedCollection}
            setSelectedCollection={selectCollection}
            selectSegment={selectSegment}
            search={search}
            setSearch={setSearch}
          />
        )}
        {type !== 'Person' && (
          <Category
            name="Company"
            collections={filteredCompanyCollections}
            onChange={onChange}
            keepOpen={type === 'Company'}
            selectedCategory={selectedCategory}
            setSelectedCategory={selectCategory}
            selectedCollection={selectedCollection}
            setSelectedCollection={selectCollection}
            selectSegment={selectSegment}
            search={search}
            setSearch={setSearch}
          />
        )}
      </div>
      {footerActions && <div className={classes.footer}>{footerActions}</div>}
    </div>
  );
};

SegmentPicker.propTypes = {
  type: PropTypes.oneOf(['Person', 'Company', 'All']).isRequired,
  classes: PropTypes.object.isRequired,
  personCollections: PropTypes.array,
  companyCollections: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  footerActions: PropTypes.node,
  className: PropTypes.string,
};

SegmentPicker.defaultProps = {
  type: 'All',
};

export const StyledPicker = withStyles(styles)(SegmentPicker);

export default withStyles(styles)(SegmentPicker);
